const currencies = {
    ALL: { name: "Albanian Lek", countryCode: "AL" },
    AFN: { name: "Afghan Afghani", countryCode: "AF" },
    AMD: { name: "Armenian Dram", countryCode: "AM" },
    ANG: { name: "Netherlands Antillean Guilder", countryCode: "NL" },
    AOA: { name: "Angolan Kwanza", countryCode: "AO" },
    ARS: { name: "Argentine Peso", countryCode: "AR" },
    AUD: { name: "Australian Dollar", countryCode: "AU" },
    AWG: { name: "Aruban Florin", countryCode: "AW" },
    AZN: { name: "Azerbaijani Manat", countryCode: "AZ" },
    BAM: { name: "Bosnia and Herzegovina Convertible Mark", countryCode: "BA" },
    BBD: { name: "Barbadian Dollar", countryCode: "BB" },
    BDT: { name: "Bangladeshi Taka", countryCode: "BD" },
    BGN: { name: "Bulgarian Lev", countryCode: "BG" },
    BHD: { name: "Bahraini Dinar", countryCode: "BH" },
    BIF: { name: "Burundian Franc", countryCode: "BI" },
    BMD: { name: "Bermudian Dollar", countryCode: "BM" },
    BND: { name: "Brunei Dollar", countryCode: "BN" },
    BOB: { name: "Bolivian Boliviano", countryCode: "BO" },
    BRL: { name: "Brazilian Real", countryCode: "BR" },
    BSD: { name: "Bahamian Dollar", countryCode: "BS" },
    BTN: { name: "Bhutanese Ngultrum", countryCode: "BT" },
    BWP: { name: "Botswana Pula", countryCode: "BW" },
    BYN: { name: "Belarusian Ruble", countryCode: "BY" },
    BZD: { name: "Belize Dollar", countryCode: "BZ" },
    CAD: { name: "Canadian Dollar", countryCode: "CA" },
    CDF: { name: "Congolese Franc", countryCode: "CD" },
    CHF: { name: "Swiss Franc", countryCode: "CH" },
    CLP: { name: "Chilean Peso", countryCode: "CL" },
    CNY: { name: "Chinese Yuan", countryCode: "CN" },
    COP: { name: "Colombian Peso", countryCode: "CO" },
    CRC: { name: "Costa Rican Colón", countryCode: "CR" },
    CUP: { name: "Cuban Peso", countryCode: "CU" },
    CVE: { name: "Cape Verdean Escudo", countryCode: "CV" },
    CZK: { name: "Czech Koruna", countryCode: "CZ" },
    DJF: { name: "Djiboutian Franc", countryCode: "DJ" },
    DKK: { name: "Danish Krone", countryCode: "DK" },
    DOP: { name: "Dominican Peso", countryCode: "DO" },
    DZD: { name: "Algerian Dinar", countryCode: "DZ" },
    EGP: { name: "Egyptian Pound", countryCode: "EG" },
    ERN: { name: "Eritrean Nakfa", countryCode: "ER" },
    ETB: { name: "Ethiopian Birr", countryCode: "ET" },
    EUR: { name: "Euro", countryCode: "EU" },
    FJD: { name: "Fijian Dollar", countryCode: "FJ" },
    FKP: { name: "Falkland Islands Pound", countryCode: "FK" },
    FOK: { name: "Faroese Króna", countryCode: "FO" },
    GBP: { name: "British Pound Sterling", countryCode: "GB" },
    GEL: { name: "Georgian Lari", countryCode: "GE" },
    GGP: { name: "Guernsey Pound", countryCode: "GG" },
    GHS: { name: "Ghanaian Cedi", countryCode: "GH" },
    GIP: { name: "Gibraltar Pound", countryCode: "GI" },
    GMD: { name: "Gambian Dalasi", countryCode: "GM" },
    GNF: { name: "Guinean Franc", countryCode: "GN" },
    GTQ: { name: "Guatemalan Quetzal", countryCode: "GT" },
    GYD: { name: "Guyanaese Dollar", countryCode: "GY" },
    HKD: { name: "Hong Kong Dollar", countryCode: "HK" },
    HNL: { name: "Honduran Lempira", countryCode: "HN" },
    HRK: { name: "Croatian Kuna", countryCode: "HR" },
    HTG: { name: "Haitian Gourde", countryCode: "HT" },
    HUF: { name: "Hungarian Forint", countryCode: "HU" },
    IDR: { name: "Indonesian Rupiah", countryCode: "ID" },
    ILS: { name: "Israeli New Shekel", countryCode: "IL" },
    IMP: { name: "Isle of Man Pound", countryCode: "IM" },
    INR: { name: "Indian Rupee", countryCode: "IN" },
    IQD: { name: "Iraqi Dinar", countryCode: "IQ" },
    IRR: { name: "Iranian Rial", countryCode: "IR" },
    ISK: { name: "Icelandic Króna", countryCode: "IS" },
    JEP: { name: "Jersey Pound", countryCode: "JE" },
    JMD: { name: "Jamaican Dollar", countryCode: "JM" },
    JOD: { name: "Jordanian Dinar", countryCode: "JO" },
    JPY: { name: "Japanese Yen", countryCode: "JP" },
    KES: { name: "Kenyan Shilling", countryCode: "KE" },
    KGS: { name: "Kyrgyzstani Som", countryCode: "KG" },
    KHR: { name: "Cambodian Riel", countryCode: "KH" },
    KID: { name: "Kiribati Dollar", countryCode: "KI" },
    KMF: { name: "Comorian Franc", countryCode: "KM" },
    KPW: { name: "North Korean Won", countryCode: "KP" },
    KRW: { name: "South Korean Won", countryCode: "KR" },
    KWD: { name: "Kuwaiti Dinar", countryCode: "KW" },
    KYD: { name: "Cayman Islands Dollar", countryCode: "KY" },
    KZT: { name: "Kazakhstani Tenge", countryCode: "KZ" },
    LAK: { name: "Laotian Kip", countryCode: "LA" },
    LBP: { name: "Lebanese Pound", countryCode: "LB" },
    LKR: { name: "Sri Lankan Rupee", countryCode: "LK" },
    LRD: { name: "Liberian Dollar", countryCode: "LR" },
    LSL: { name: "Lesotho Loti", countryCode: "LS" },
    LYD: { name: "Libyan Dinar", countryCode: "LY" },
    MAD: { name: "Moroccan Dirham", countryCode: "MA" },
    MDL: { name: "Moldovan Leu", countryCode: "MD" },
    MGA: { name: "Malagasy Ariary", countryCode: "MG" },
    MKD: { name: "Macedonian Denar", countryCode: "MK" },
    MMK: { name: "Myanmar Kyat", countryCode: "MM" },
    MNT: { name: "Mongolian Tugrik", countryCode: "MN" },
    MOP: { name: "Macanese Pataca", countryCode: "MO" },
    MRU: { name: "Mauritanian Ouguiya", countryCode: "MR" },
    MUR: { name: "Mauritian Rupee", countryCode: "MU" },
    MVR: { name: "Maldivian Rufiyaa", countryCode: "MV" },
    MWK: { name: "Malawian Kwacha", countryCode: "MW" },
    MXN: { name: "Mexican Peso", countryCode: "MX" },
    MYR: { name: "Malaysian Ringgit", countryCode: "MY" },
    MZN: { name: "Mozambican Metical", countryCode: "MZ" },
    NAD: { name: "Namibian Dollar", countryCode: "NA" },
    NGN: { name: "Nigerian Naira", countryCode: "NG" },
    NIO: { name: "Nicaraguan Córdoba", countryCode: "NI" },
    NOK: { name: "Norwegian Krone", countryCode: "NO" },
    NPR: { name: "Nepalese Rupee", countryCode: "NP" },
    NZD: { name: "New Zealand Dollar", countryCode: "NZ" },
    OMR: { name: "Omani Rial", countryCode: "OM" },
    PAB: { name: "Panamanian Balboa", countryCode: "PA" },
    PEN: { name: "Peruvian Nuevo Sol", countryCode: "PE" },
    PGK: { name: "Papua New Guinean Kina", countryCode: "PG" },
    PHP: { name: "Philippine Peso", countryCode: "PH" },
    PKR: { name: "Pakistani Rupee", countryCode: "PK" },
    PLN: { name: "Polish Złoty", countryCode: "PL" },
    PYG: { name: "Paraguayan Guarani", countryCode: "PY" },
    QAR: { name: "Qatari Rial", countryCode: "QA" },
    RON: { name: "Romanian Leu", countryCode: "RO" },
    RSD: { name: "Serbian Dinar", countryCode: "RS" },
    RUB: { name: "Russian Ruble", countryCode: "RU" },
    RWF: { name: "Rwandan Franc", countryCode: "RW" },
    SAR: { name: "Saudi Riyal", countryCode: "SA" },
    SBD: { name: "Solomon Islands Dollar", countryCode: "SB" },
    SCR: { name: "Seychellois Rupee", countryCode: "SC" },
    SDG: { name: "Sudanese Pound", countryCode: "SD" },
    SEK: { name: "Swedish Krona", countryCode: "SE" },
    SGD: { name: "Singapore Dollar", countryCode: "SG" },
    SHP: { name: "Saint Helena Pound", countryCode: "SH" },
    SLL: { name: "Sierra Leonean Leone", countryCode: "SL" },
    SOS: { name: "Somali Shilling", countryCode: "SO" },
    SRD: { name: "Surinamese Dollar", countryCode: "SR" },
    SSP: { name: "South Sudanese Pound", countryCode: "SS" },
    STN: { name: "São Tomé and Príncipe Dobra", countryCode: "ST" },
    SVC: { name: "Salvadoran Colón", countryCode: "SV" },
    SYP: { name: "Syrian Pound", countryCode: "SY" },
    SZL: { name: "Swazi Lilangeni", countryCode: "SZ" },
    THB: { name: "Thai Baht", countryCode: "TH" },
    TJS: { name: "Tajikistani Somoni", countryCode: "TJ" },
    TMT: { name: "Turkmenistani Manat", countryCode: "TM" },
    TND: { name: "Tunisian Dinar", countryCode: "TN" },
    TOP: { name: "Tongan Pa'anga", countryCode: "TO" },
    TRY: { name: "Turkish Lira", countryCode: "TR" },
    TTD: { name: "Trinidad and Tobago Dollar", countryCode: "TT" },
    TWD: { name: "New Taiwan Dollar", countryCode: "TW" },
    TZS: { name: "Tanzanian Shilling", countryCode: "TZ" },
    UAH: { name: "Ukrainian Hryvnia", countryCode: "UA" },
    UGX: { name: "Ugandan Shilling", countryCode: "UG" },
    USD: { name: "United States Dollar", countryCode: "US" },
    UYU: { name: "Uruguayan Peso", countryCode: "UY" },
    UZS: { name: "Uzbekistani Som", countryCode: "UZ" },
    VES: { name: "Venezuelan Bolívar", countryCode: "VE" },
    VND: { name: "Vietnamese Đồng", countryCode: "VN" },
    VUV: { name: "Vanuatu Vatu", countryCode: "VU" },
    WST: { name: "Samoan Tala", countryCode: "WS" },
    XAF: { name: "Central African CFA Franc", countryCode: "CM" },
    XCD: { name: "East Caribbean Dollar", countryCode: "LC" },
    XOF: { name: "West African CFA Franc", countryCode: "CI" },
    XPF: { name: "CFP Franc", countryCode: "PF" },
    YER: { name: "Yemeni Rial", countryCode: "YE" },
    ZAR: { name: "South African Rand", countryCode: "ZA" },
    ZMW: { name: "Zambian Kwacha", countryCode: "ZM" },
    ZWL: { name: "Zimbabwean Dollar", countryCode: "ZW" },
};

export default currencies;
